import { format, parseISO, startOfWeek, endOfWeek, subDays, differenceInDays } from 'date-fns';

export function formatDate(date) {
  return format(typeof date === 'string' ? parseISO(date) : date, 'MMM d, yyyy');
}

export function formatDateShort(date) {
  return format(typeof date === 'string' ? parseISO(date) : date, 'MMM d');
}

export function toISODate(date) {
  return format(date, 'yyyy-MM-dd');
}

export function getThisWeekRange() {
  const now = new Date();
  return {
    start: toISODate(startOfWeek(now, { weekStartsOn: 1 })),
    end: toISODate(endOfWeek(now, { weekStartsOn: 1 })),
  };
}

export function getLast30DaysRange() {
  const now = new Date();
  return {
    start: toISODate(subDays(now, 30)),
    end: toISODate(now),
  };
}

export function daysSince(dateStr) {
  if (!dateStr) return null;
  return differenceInDays(new Date(), parseISO(dateStr));
}
